module.exports = __webpack_public_path__ + "static/media/business-outline.f8eb6005.svg";